import React from 'react';

const NaturalPrice = props => {
  return (
    <React.Fragment>
      <div className="PlanDetailNaturalPrice">
        <div className="PlanDetailNaturalPriceValue" >
          通常料金 /月
          {`${props.price}円`}
        </div>
        <div className="PlanDetailNaturalPriceDetail" >
          （税込 {`${props.priceWithTax}円`}）
        </div>
      </div>
    </React.Fragment>
  );
};

export default NaturalPrice;
